import React from 'react';
import ssCompanyLogo from '../images/ss-company-logo.svg';
import '../AuthScreens.css';

const AuthShell = ({title, loading = false, children}) => (
  <main className="auth-screen">
    {loading && (
      <div className="auth-loading" role="status">
        Please wait...
      </div>
    )}
    <section className="auth-panel">
      <img className="auth-logo" src={ssCompanyLogo} alt="SS Company" />
      <h1 className="auth-title">{title}</h1>
      {children}
    </section>
  </main>
);

export default AuthShell;
